// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1458) return "static/chunks/1458-40ec359c6d9c5276.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1379":"19483493012ed919","3114":"8751c15812c7287d","3993":"c5597db88cb77e39","4148":"caa49a3deadbe90e","6620":"06344729857ab34f","7283":"c125de0f31114543","9788":"22f2df38f9c1fb9a"}[chunkId] + ".js";
};